module.exports = __webpack_public_path__ + "img/TV_Adverts_2_Background.b4bc8835.jpg";